/**
 * @description 读取json文件
 * @param {File} file 
 */
export function readJsonFile(file) {
  let fileReader = new FileReader();
  fileReader.readAsText(file);
  return new Promise((resolve, reject) => {
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (e) => reject(e);
  });

} 